
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Vendor } from '../../../models/vendor.model';
import { Benefit } from '../../../models/benefit.model';
import { AlertService, DialogType } from '../../../services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { ProductBenefit } from '../../../models/product-benefit.model';
import { BenefitType } from '../../../models/benefit-type.model';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { BenefitClassification } from '../../../models/benefit-classification.model';


@Component({
    selector: 'create-edit-benefit-modal',
    template: require('./create-edit-benefit-modal.component.html'),
    styles: [require('./create-edit-benefit-modal.component.css')]
})
export class CreateEditBenefitModalComponent {
    vendors: Vendor[];
    currentBenefit: Benefit;
    productId: number;
    searchCtrl = new FormControl();
    currentBenefitTypeName = "";

    benefitTypesSearch: Observable<BenefitType[]>;
    benefitTypes: Observable<BenefitType[]>;
    benefitClassifications: Observable<BenefitClassification[]>;

    constructor(private route: ActivatedRoute, private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditBenefitModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.vendors = data.vendors;
        this.currentBenefit = data.currentBenefit;
        this.productId = data.productId;


        this.benefitTypes = this.apiService.getBenefitTypes();
        this.benefitClassifications = this.apiService.getBenefitClassifications();

        this.benefitTypesSearch = this.searchCtrl.valueChanges
            .startWith(null)
            .debounceTime(200)
            .distinctUntilChanged()
            .switchMap(val => {
                return this.search(val || '')
            })

    }

    displayFn(bt?: BenefitType): string | undefined {
        return bt ? bt.name : undefined;
    }

    addNewBenefitType() {
        if (!this.searchCtrl.value || !this.searchCtrl.value.name  ) {
            return;
        }
        if (typeof this.searchCtrl.value.name != 'string') {
            this.currentBenefit.benefitType = this.searchCtrl.value.name;
            return;
        }

        this.alertService.showDialog("Do you want to add a new Benefit Type named " + this.searchCtrl.value.name +"?", DialogType.confirm, val => {

            this.apiService.createBenefitType(this.searchCtrl.value).subscribe(r => {
                this.currentBenefit.benefitTypeId = r.benefitTypeId;
                //this.getVendors();
            });
        });
    }

    search(val: string) {
        if (typeof val !== 'string') {
            return [];
        }
        return this.benefitTypes
            .map(response => response.filter(option => {
                return option.name.toLowerCase().indexOf(val.toLowerCase()) === 0
            }));
    }

    ok() {
        if (this.currentBenefit.benefitId) {
            this.apiService.updateBenefit(this.currentBenefit).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Benefit successfully");
                }
            });
        } else {
            if (this.productId) {
                var productBenefit = new ProductBenefit();
                productBenefit.productId = this.productId;
                this.currentBenefit.productBenefits = [new ProductBenefit({ productId: this.productId})];

            }
            if (this.currentBenefit.benefitType && !this.currentBenefit.benefitTypeId) {
                this.currentBenefit.benefitTypeId = this.currentBenefit.benefitType.benefitTypeId;
                this.currentBenefit.benefitType = null;
            }
            this.apiService.createBenefit(this.currentBenefit).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Benefit successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/benefits/create-edit-benefit-modal/create-edit-benefit-modal.component.ts